import React from "react";
import WofButton from "../WofButton";
import "./styles.scss";
import CalendarInvitationCTA from "../CalendarInvitationCTA";

const ImageCard: React.FC<any> = ({
  image,
  alt,
  title,
  titleColor,
  ctabaseColor,
  ctahoverColor,
  ctaText,
  ctaLink,
  mobilebackground,
  fullCardLinkUrl,
  calendarInvitationCTA
}) => {
  return (
    <div className="image-card">
      <div className="position-relative">
        {fullCardLinkUrl ? (
          <a href={fullCardLinkUrl}>
            <img
              src={image}
              className={"desktop-image"}
              alt={alt || title}
              id={"imagecardBG"}
            />
          </a>
        ) : (
          <>
            {" "}
            <img
              src={image}
              className={"desktop-image"}
              alt={alt || title}
              id={"imagecardBG"}
            />
          </>
        )}

        {fullCardLinkUrl ? (
          <a href={fullCardLinkUrl}>
            <img
              src={mobilebackground}
              className={"mobile-image"}
              alt={alt || title}
              id={"imagecardBG"}
            />
          </a>
        ) : (
          <>
            {" "}
            <img
              src={mobilebackground}
              className={"mobile-image"}
              alt={alt || title}
              id={"imagecardBG"}
            />
          </>
        )}

        <h1 className="title position-absolute" style={{ color: titleColor }}>
          {title}
        </h1>
        <div className="bottom position-absolute">
          {ctaText ? (
            <WofButton
              baseColor={ctabaseColor}
              hoverColor={ctahoverColor}
              href={ctaLink}
            >
              {ctaText}
            </WofButton>
          ) : null}
          {calendarInvitationCTA && Object.keys(calendarInvitationCTA).length > 0 && Object.getPrototypeOf(calendarInvitationCTA) === Object.prototype ?
            (
              <CalendarInvitationCTA calendarEventData={calendarInvitationCTA} />
            ) : null
          }
        </div>
      </div>
    </div>
  );
};
export default ImageCard;

